import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "section", "emptyState"]

  connect() {
    this.openFromHash()
    window.addEventListener("hashchange", () => this.openFromHash())
  }

  search(event) {
    if (event) event.preventDefault()

    const rawQuery = this.inputTarget.value.trim()
    const query = this.normalize(rawQuery)
    let visibleCount = 0

    if (query === "") {
      this.itemTargets.forEach(item => {
        item.classList.remove("is-hidden")
        item.open = false
      })
      this.sectionTargets.forEach(section => section.classList.remove("is-hidden"))
      this.emptyStateTarget.classList.add("is-hidden")
      return
    }

    this.itemTargets.forEach(item => {
      const itemText = this.normalize(item.textContent)
      const matches = itemText.includes(query)

      item.classList.toggle("is-hidden", !matches)
      if (matches) {
        item.open = true
        visibleCount++
      }
    })

    // Masque les sections qui n'ont aucune question visible
    this.sectionTargets.forEach(section => {
      const hasVisibleItems = section.querySelector(".faq-item:not(.is-hidden)") !== null
      section.classList.toggle("is-hidden", !hasVisibleItems)
    })

    this.emptyStateTarget.classList.toggle("is-hidden", visibleCount > 0)
  }

  openFromHash() {
    const hash = window.location.hash
    if (!hash) return

    const targetSection = document.querySelector(hash)
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: "smooth", block: "start" })
      const firstDetails = targetSection.querySelector("details")
      if (firstDetails) firstDetails.open = true
    }
  }

  // Supprime les accents et met en minuscules pour faciliter la recherche
  normalize(string) {
    return string
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
  }
}